import { fetchAuthSession } from "aws-amplify/auth";
import { ILocation, normalizeLocation } from "./models/ILocation";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import awsmobile from "../aws-exports";
import { Buffer } from "buffer";
import { getModuleLog } from "./Logger";

export async function elevationAtLocation(location: ILocation): Promise<number | undefined> {
    try {
        location = normalizeLocation(location);

        const { credentials } = await fetchAuthSession();
        const client = new LambdaClient({
            region: awsmobile.aws_project_region,
            credentials: credentials,
        });
        const command = new InvokeCommand({
            FunctionName: "arn:aws:lambda:ap-southeast-2:357355541153:function:cavedbElevation-dev",
            Payload: JSON.stringify({
                lat: location.lat,
                lon: location.lon,
            }) as unknown as Uint8Array,
        });
        const { Payload: payload } = (await client.send(command)) as any;
        const response = JSON.parse(Buffer.from(payload).toString());
        const result = JSON.parse(response.body);
        if (result && "results" in result && result["results"].length > 0) {
            return result.results[0].elevation;
        }
    } catch (error) {
        getModuleLog("elevation").error(
            `Failed to get elevation for [${location.lat.toFixed(5)}, ${location.lon.toFixed(
                5
            )}] : ${error}`
        );
    }

    return undefined;
}
